import { Route } from '@angular/router';
import { CanDeactivateGuard } from '@clean-code/shared/components/ui-can-deactivate';

export const formulaBuilderRoutes: Route = {
  path: 'formulas',
  loadComponent: () =>
    import('@clean-code/feature/formula-builder/formula-builder-list').then(
      (mod) => mod.FormulaBuilderListComponent
    ),
  children: [
    {
      path: 'preview/:id',
      loadComponent: () =>
        import('@clean-code/feature/formula-builder/formula-builder-list').then(
          (mod) => mod.FormulaBuilderFormComponent
        ),
      canDeactivate: [CanDeactivateGuard],
    },
  ],
};
